import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=9b1523f0&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=9b1523f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1523f0",
  null
  
)

export default component.exports